"use client";

import { IconCookie } from "@tabler/icons-react";

type SourcepointEvents = "onSPPMObjectReady" | "onMessageReceiveData" | "onMessageReady";

declare global {
	interface Window {
		_sp_?: {
			loadPrivacyManagerModal: (id: number) => void;
			addEventListener: (event: SourcepointEvents, callback: () => void) => void;
			removeEventListener: (event: SourcepointEvents, callback: () => void) => void;
		};
	}
}

const SourcepointCookieWindow = () => {
	const openCookieConsent = () => {
		window._sp_?.loadPrivacyManagerModal(1224524);
	};

	return (
		<div
			className="fixed bottom-0 left-0 z-50 w-10 h-10 bg-bg-tertiary rounded-tr-3xl flex justify-center items-center cursor-pointer hover:scale-125 transform transition-transform duration-300"
			onClick={openCookieConsent}
		>
			<IconCookie size={30} stroke={1.7} />
		</div>
	);
};

export default SourcepointCookieWindow;
